// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';
import * as dateUtil from '@/utils/parsing';
/**
 * 绑定产品
 * @param pram
 */
export function bindProduct(pram) {
  var data = {
    id: pram.id,
    productId: pram.productId
  };
  return request({
    url: '/admin/article/bind/product',
    method: 'POST',
    params: data
  });
}

/**
 * 删除文章
 * @param id
 * @constructor
 */
export function DelArticle(pram) {
  var data = {
    id: pram.id
  };
  return request({
    url: '/admin/article/delete',
    method: 'GET',
    params: data
  });
}

/**
 * 文章详情
 * @param id
 * @constructor
 */
export function InfoArticle(id) {
  var data = {
    id: id
  };
  return request({
    url: '/admin/article/info',
    method: 'get',
    params: data
  });
}

/**
 * 文章列表
 * @param pram
 * @constructor
 */
export function ListArticle(pram) {
  var data = {
    keywords: pram.keywords,
    cid: pram.cid,
    isActivity: pram.isActivity,
    page: pram.page,
    limit: pram.limit
  };
  return request({
    url: '/admin/article/list',
    method: 'GET',
    params: data
  });
}

/**
 * 新增文章
 * @param pram
 * @constructor
 */
export function AddArticle(pram) {
  var data = {
    author: pram.author,
    cid: pram.cid,
    content: pram.content,
    imageInput: pram.imageInput,
    isBanner: pram.isBanner,
    isHot: pram.isHot,
    shareSynopsis: pram.shareSynopsis,
    shareTitle: pram.shareTitle,
    sort: pram.sort,
    synopsis: pram.synopsis,
    title: pram.title,
    url: pram.url,
    isActivity: pram.isActivity,
    type: pram.type,
    videoInfo: pram.videoInfo,
    roleList: pram.roleList.join(','),
    activityRequest: {
      posterUrl: pram.activityRequest.posterUrl,
      detail: pram.activityRequest.detail,
      subjectName: pram.activityRequest.subjectName,
      province: pram.activityRequest.province,
      city: pram.activityRequest.city,
      district: pram.activityRequest.district,
      timesList: []
    },
    tagIdList: pram.tagIdList
  };
  if (pram.roleList && pram.roleList.length) {
    data.roleList = pram.roleList.join(',');
  } else {
    data.roleList = '';
  }
  pram.activityRequest.timesList.forEach(function (e) {
    data.activityRequest.timesList.push({
      startTime: e.startTime,
      endTime: e.endTime
    });
  });
  return request({
    url: '/admin/article/save',
    method: 'post',
    data: data
  });
}

/**
 * 更新文章
 * @param pram
 * @constructor
 */
export function UpdateArticle(pram) {
  var data = {
    author: pram.author,
    cid: pram.cid,
    content: pram.content,
    imageInput: pram.imageInput,
    isBanner: pram.isBanner,
    isWhiteSpace: pram.isWhiteSpace,
    isHot: pram.isHot,
    shareSynopsis: pram.shareSynopsis,
    shareTitle: pram.shareTitle,
    sort: pram.sort,
    synopsis: pram.synopsis,
    title: pram.title,
    url: pram.url,
    isActivity: pram.isActivity,
    type: pram.type,
    videoInfo: pram.videoInfo,
    roleList: pram.roleList.join(','),
    activityRequest: {
      id: pram.activityRequest.id,
      posterUrl: pram.activityRequest.posterUrl,
      detail: pram.activityRequest.detail,
      subjectName: pram.activityRequest.subjectName,
      province: pram.activityRequest.province,
      city: pram.activityRequest.city,
      district: pram.activityRequest.district,
      timesList: pram.activityRequest.timesList
    },
    tagIdList: pram.tagIdList
  };
  if (pram.roleList && pram.roleList.length) {
    data.roleList = pram.roleList.join(',');
  } else {
    data.roleList = '';
  }
  return request({
    url: '/admin/article/update',
    method: 'post',
    params: {
      id: pram.id
    },
    data: data
  });
}
export function getPage(data) {
  return request({
    url: '/admin/article/getListActivity',
    method: 'get',
    params: data
  });
}
export function getPageActivity(data) {
  return request({
    url: '/admin/article/activity/list',
    method: 'get',
    params: data
  });
}
// 删除生活达人
export function deleteByUidAirApi(data) {
  return request({
    url: '/admin/article/deleteByUid',
    method: 'post',
    data: data
  });
}
// 查询楼盘信息
export function findHousesInfoArticle(data) {
  return request({
    url: '/admin/article/findHousesInfo',
    method: 'post',
    data: data
  });
}
// 查询生活达人列表
export function findUserListAirApi(data) {
  return request({
    url: '/admin/article/findUserList',
    method: 'post',
    data: data
  });
}
// 修改文章关联楼盘信息
export function saveArticleHousesApi(data) {
  return request({
    url: '/admin/article/saveArticleHouses',
    method: 'post',
    data: data
  });
}
// 修改生活达人授权状态
export function switchStatusAirArticle(data) {
  return request({
    url: '/admin/article/switchStatus',
    method: 'post',
    data: data
  });
}
// 修改文章关联生活达人信息
export function updateArticleUserAir(data) {
  return request({
    url: '/admin/article/updateArticleUser',
    method: 'post',
    data: data
  });
}
// 文章关联楼盘信息取消
export function cancelArticleHousesApi(data) {
  return request({
    url: '/admin/article/cancelArticleHouses',
    method: 'post',
    data: data
  });
}